export default {
  colors: {
    primary: '#001E42',               // Blue Oxford
    secondary: '#258EA6',            // Blue Munshell
    blue: '#097BBF',

    lightGray: '#BCC9D7',            // Light Gray
    mediumGray: '#7F868C',            // Medium Gray
    darkGray: '#33475B',
    white: '#FDFFFC',                   // White
    black: '#1C1C1D',                // Black Chocolate
    lightBlue: '#F8FBFF',
    mediumBlue: '#224579',
    darkBlue: '#003465',
    darkOrange: '#F47500',
    mediumOrange: '#F79120',
    red: '#D64045',
    green: '#4DAA57',
    yellow: '#FFF05A',

    background: {
      gray: '#F3F7F7',
      blueGradient: 'linear-gradient(180deg, #003465 0%, #004385 100%)',
      orangeGradient: 'linear-gradient(180deg, #F79120 0%, #F47500 100%)',
    },

    text: {
      white: '#F4F6F7',
      gray: '#33475B',
      lightGray: '#BCC9D7',
      blue: '#224579'
    },

    button: {
      primary: '#258EA6',
      primaryHover: '#076980',
      orangeGradient: 'linear-gradient(180deg, #F47500 0%, #F79120 100%)',
    },

    badge: {
      background: 'rgba(9, 123, 191, 0.2);',
      text: '#097BBF'
    }
  },

  shadows: {
    card: '0px 2px 10px rgba(0, 0, 0, 0.15)',
    // text: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  }
};